import {useNavigate, useSearchParams} from "react-router-dom";
import {trailerSelector, useGetTrailerQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {TrailerProfile} from "../../components/profile/TrailerProfile/TrailerProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const TrailerProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.trailer", "Trailer") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <TrailerProfilePage id={id}/>;
};

export const TrailerProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectTrailer = useMemo(() => {
    return trailerSelector()
  }, []);

  const {trailer, isFetching} = useGetTrailerQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      trailer: selectTrailer(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage permissions={["trailer_view"]} entity={trailer} isLoading={isFetching} onAccess={setAccess}>
      {(entity) => (
        <TrailerProfile trailer={entity}/>
      )}
    </EntityProfilePage>
  )
};
